<template>
  <div class="row">
    <div class="modal fade" id="changeProfileModal" style="z-index: 1500;">
      <div class="modal-dialog modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title">Cập nhật thông tin</h4>
                  <button type="button" class="close" aria-label="Close" @click="hideChangeProfileModal()">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                <div class="row mb-2">
                    <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                        Họ tên <span class="text-danger">(*)</span>
                    </label>
                    <div class="col-sm-9">
                        <input class="form-control" type="text" placeholder="Nhập họ tên" v-model="model.hoTen" @blur="validateChangeProfile()" :class="{ 'is-invalid': errors.hoTen }" />
                    </div>
                </div>
                <small class="text-danger text-right mb-2 d-block" v-if="errors.hoTen">{{ errors.hoTen }}</small>

                <div class="row mb-2">
                    <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                        Giới tính <span class="text-danger">(*)</span>
                    </label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="model.gioiTinh">
                        <option value="0">Nam</option>
                        <option value="1">Nữ</option>
                      </select>
                    </div>
                </div>
                <small class="text-danger text-right mb-2 d-block" v-if="errors.gioiTinh">{{ errors.gioiTinh }}</small>

                <div class="row mb-2">
                    <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                        Email <span class="text-danger">(*)</span>
                    </label>
                    <div class="col-sm-9">
                        <input class="form-control" type="text" placeholder="Nhập email" v-model="model.email" @blur="validateChangeProfile()" :class="{ 'is-invalid': errors.email }" />
                    </div>
                </div>
                <small class="text-danger text-right mb-2 d-block" v-if="errors.email">{{ errors.email }}</small>

                <div class="row mb-2">
                    <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                        Số điện thoại <span class="text-danger">(*)</span>
                    </label>
                    <div class="col-sm-9">
                        <input class="form-control" type="text" placeholder="Nhập lại mật khẩu" v-model="model.sdt" @blur="validateChangeProfile()" :class="{ 'is-invalid': errors.sdt }" />
                    </div>
                </div>
                <small class="text-danger text-right mb-2 d-block" v-if="errors.sdt">{{ errors.sdt }}</small>
              </div>
              <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-outline-dark pull-left" data-dismiss="modal">&nbsp;Đóng</button>
                  <button type="button" class="btn btn-outline-primary pull-right" :disabled="submitted" @click="onSubmitChangeProfile();">
                      <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      &nbsp;Cập nhật
                  </button>
              </div>
          </div>
      </div>
    </div>
  </div>


</template>

<script>
import $ from 'jquery';
import { userModel } from '@/models/user.model';
import { mapState, mapActions } from 'vuex';
import common from '@/helper/common.js';
export default {
  name: "TheChangeProfile",
  data() {
    return {
      errors: {
        
      },
      model: userModel.newModel(),
      submitted: false,
      user: null
    }
  },
  // computed: {
  //   ...mapState({
  //     user: state => state.authentication.user
  //   })
  // },
  methods: {
    ...mapActions('user', ['updateProfile']),

    hideChangeProfileModal(){
      $('#changeProfileModal').modal('hide');
    },

    // validate
    validateChangeProfile() {
      let isvalid = true
      // set up errors
      this.errors = {
        hoTen: null,
        gioiTinh: null,
        email: null,
        sdt: null
      }
      // check null model
      if (!this.model.hoTen) {
        this.errors.hoTen = "Nhập họ tên";
        isvalid = false;
      }
      if (!this.model.email) {
        this.errors.email = 'Nhập email';
        isvalid = false;
      } else if (!common.validateEmail(this.model.email)) {
        this.errors.email = 'Không phải email';
        isvalid = false;
      }

      if (!this.model.sdt) {
        this.errors.sdt = 'Nhập số điện thoại';
        isvalid = false;
      } else if (!common.validatePhoneNumber(this.model.sdt)) {
        this.errors.sdt = 'Không phải số điện thoại';
        isvalid = false;
      }

      return isvalid;
    },
    // submit function 
    onSubmitChangeProfile() {
      this.submitted = true;
      if (this.validateChangeProfile()) {
        this.updateProfile(this.model);
        this.hideChangeProfileModal();
      }
      this.submitted = false;
    },
  },
  created() {
    this.model = JSON.parse(localStorage.getItem('user_profile'));
  }
}
</script>

<style>
</style>